import { useEffect } from 'react'
import { isNullOrEmpty } from '../../../common/Helpers';

const useCalculateStatusfly = (objBoard, boardElements, statusFly, setStatusFly) => {    
    useEffect(()=> {
        const getData = async () => {
            if (objBoard.id !== null){
                if (objBoard.name !== null && objBoard.name !== "" && objBoard.id !== null){
                    if (boardElements !== null && boardElements.length > 0) {
                        if (boardElements.filter((obj) => !isNullOrEmpty(obj.htmlColor) && obj.l_roles.length > 0 && obj.l_variables.length > 0).length === boardElements.length) {   
                            if (objBoard.statusId === 2 || objBoard.statusId === 3) {
                                statusFly = 5;
                            }
                            else {
                                statusFly = 4;     
                            } 
                        }
                        else {
                            statusFly = 3;
                        }
                    } else {
                        statusFly = 2;
                    }
                }
                else {
                    statusFly = 1;
                }
            }
            else {
                statusFly = 0;
            }
    
            setStatusFly && setStatusFly(
                { status: statusFly, fireUpdate: false }
            )
        }
        
        if (objBoard !== undefined && objBoard.id !== null && boardElements !== null && statusFly.fireUpdate === true) {
            getData()
        }
    }, [objBoard, boardElements, statusFly, setStatusFly]);
}

export {
    useCalculateStatusfly
}